<template>
    <ui-card>
        <b-skeleton v-if="title" width="40%" height="1.1rem" class="mb-4"/>
        <b-skeleton v-for="n in lines" :key="n" :width="widths[(n - 1) % widths.length]" :animated="true" class="mb-2"/>
    </ui-card>
</template>

<script>
    import UiCard from "../UiCard";

    // Loading placeholder for a dashboard card: a white ui-card with a few
    // shimmering lines, so the page keeps its shape while a section loads.
    export default {
        name: "CardSkeleton",
        components: {UiCard},
        props: {
            lines: {type: Number, default: 3},
            title: {type: Boolean, default: true},
        },
        data() {
            return {widths: ['90%', '70%', '80%', '55%']};
        }
    };
</script>
